import { AppRouteConfig } from '@meplis/common';

export const AppRoutes: Record<string, AppRouteConfig> = {
  PROGRAMS: {
    title: 'COMPONENT.MAIN_MENU.ITEM.PROGRAMS',
    fullPath: 'programs',
  },
  PROFILE: { title: 'PROFILE', fullPath: 'profile' },
  LOGIN: { title: 'LOGIN', fullPath: 'login' },
  SIGN_UP: { title: 'SIGN_UP', fullPath: 'sign-up' },
  RECOVERY_PASSWORD: {
    title: 'AUT.RECOVER_PASSWORD.RECOVER.TITLE',
    fullPath: 'recovery-password',
  },
  PROGRAM: {
    title: 'COMPONENT.MAIN_MENU.ITEM.PROGRAMS',
    fullPath: 'program/run/:id',
  },
  PROGRAM_ANSWERED: {
    title: 'COMPONENT.MAIN_MENU.ITEM.PROGRAMS',
    fullPath: 'program/show/:id',
  },
};
